import * as React from "react";
import StudentTag from "../../../../domains/StudentTag";
import { ActiveOperator } from "../../../../interfaces/SectionOperatorsInterface";
import OperatorTagSwitch from "./OperatorTagSwitch/index";

interface Props {
  operator: ActiveOperator;
  currentOperatorId: string;
  sectionId: string;
  sectionTags: StudentTag[];
  isPending: boolean;
  onTagsChange: (tagIds: string[], onSuccess: () => void) => void;
}

const OperatorTagForm: React.FC<Props> = ({
  operator,
  currentOperatorId,
  sectionId,
  sectionTags,
  isPending,
  onTagsChange,
}) => {
  if (operator.isAdmin || operator.id === currentOperatorId) {
    return <p>ー</p>;
  }

  return (
    <OperatorTagSwitch
      operator={operator}
      sectionId={sectionId}
      sectionTags={sectionTags}
      isPending={isPending}
      onTagsChange={onTagsChange}
    />
  );
};

export default OperatorTagForm;
